import { UserDto } from '@/apiclient/apiclient_generated';

export default class MaterialRequestService {
  static isMaterialRequestEmailsAvailable(user: UserDto) {
    return user.isAdmin || user.isSuperAdmin || user.isMaterialRequestAdmin;
  }
}
